import styled from 'styled-components'
import { print } from '../styles'
import {
  compose,
  space,
  layout,
  typography,
  color,
  background,
  border,
  shadow,
} from 'styled-system'

const SimpleTableFootCell = styled.td`
  ${print}
  ${compose(space, typography, color, layout, background, border, shadow)}
`

SimpleTableFootCell.defaultProps = {
  fontSize: 'small',
  color: 'neutral.0',
  py: 'medium',
  px: 'xlarge',
  borderColor: 'neutral.2',
  borderWidth: 'xthin',
  borderTopStyle: 'solid',
}

export default SimpleTableFootCell
